import { SITE_NAME, DOMAIN } from 'Config/config'

export default (currentArea) => {
  const title = `Our Agents | ${SITE_NAME}.ca`
  const description = `Hire a ${SITE_NAME}.ca expert and get the edge in today’s competitive marketplace.`
  return ([
    {
      'tag': 'meta',
      'property': 'og:site_name',
      'content': `${SITE_NAME}.ca`,
    },
    {
      'tag': 'meta',
      'charSet': 'utf-8',
    },
    {
      'tag': 'title',
      'content': title,
    },
    {
      'tag': 'meta',
      'property': 'og:title',
      'content': title,
    },
    {
      'tag': 'meta',
      'property': 'og:description',
      'content': description,
    },
    {
      'tag': 'meta',
      'name': 'description',
      'content': description,
    },
    {
      'tag': 'meta',
      'property': 'geo.region',
      'content': 'CA-ON',
    },
    {
      'tag': 'meta',
      'name': 'keywords',
      'content': `${currentArea} ,Real Estate Agents, ${currentArea} realtors`,
    },
    {
      'tag': 'meta',
      'http-equiv': 'content-type',
      'content': 'text/html; charset=UTF-8',
    },
    {
      'tag': 'meta',
      'http-equiv': 'content-language',
      'content': 'en-US',
    },
    {
      'tag': 'link',
      'rel': 'canonical',
      'href': `https://${DOMAIN}/agents`,
    },
  ]
  )
}
